import { NavBar } from './nav-bar'

const Layout = ({ children }) => {
  return (
    <div className="min-h-[calc(var(--vh)*100)] md:h-screen md:max-h-screen lg:flex flex-col noScrollbar">
      <NavBar />
      {/* Allow children to shrink and avoid being clipped */}
      <div className="w-full justify-center flex h-full min-h-0 noScrollbar">{children}</div>
    </div>
  )
}

export default Layout
